import React from "react";
import { PageWrap, Ornament } from "./HomePageStyles";

import Carousel from "../../components/Carousel/Carousel";
import InfoDelivery from "../../components/InfoDelivery/InfoDelivery";
import poveste from "../../assets/images/Poveste.jpg";

import HeroCarousel from "../../components/HeroCarousel/HeroCarousel";
import StorySection from "../../components/StorySection/StorySection";
import GalleryBlock from "../../components/GalleryBlock/GalleryBlock";
import FeatureTriptych from "../../components/FeatureTriptych/FeatureTriptych";
import ContactInfo from "../../components/ContactInfo/ContactInfo";

import g1 from "../../assets/images/pizza.png";
import g2 from "../../assets/images/paste.png";
import g3 from "../../assets/images/papanasi.png";
import g4 from "../../assets/images/tochitura.png";

import Oferta1 from "../../assets/images/Oferta1.png";
import Oferta2 from "../../assets/images/Oferta2.png";
import Oferta3 from "../../assets/images/Oferta3.png";

import hero1 from "../../assets/images/Carousel1.jpg";
import hero2 from "../../assets/images/Carousel2.jpg";
import hero3 from "../../assets/images/Carousel3.jpg";
import hero4 from "../../assets/images/Carousel4.jpg";
import hero5 from "../../assets/images/Carousel5.jpg";
import hero6 from "../../assets/images/Carousel6.jpg";
import hero7 from "../../assets/images/Carousel7.jpg";

import pizzaImg from "../../assets/images/pizza.png";
import pasteImg from "../../assets/images/paste.png";
import papanasiImg from "../../assets/images/papanasi.png";

import { useTranslation } from "react-i18next";
import { useExperience } from "../../context/ExperienceContext";
import { useNavigate, useLocation } from "react-router-dom";

import SEO from "../../components/SEO/SEO";

export default function HomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { experience } = useExperience();

  // determinăm experiența curentă
  const effectiveExperience =
    experience ||
    (location.pathname.startsWith("/meniu_restaurant")
      ? "restaurant"
      : location.pathname.startsWith("/meniu_delivery")
      ? "delivery"
      : null);

  const baseMenuPath =
    effectiveExperience === "restaurant"
      ? "/meniu_restaurant/"
      : "/meniu_delivery/";

  const menuHref = (cat) =>
    cat ? `${baseMenuPath}?cat=${encodeURIComponent(cat)}` : baseMenuPath;

  const isRestaurant = effectiveExperience === "restaurant";

  // --- SLIDES HERO ---
  const slidesHero = [
    {
      key: "hero1",
      src: hero1,
      alt: "Interior restaurant",
      title: t("home.hero1.title"),
      text: t("home.hero1.text"),
      onClick: () => navigate(baseMenuPath),
    },
    {
      key: "hero2",
      src: hero2,
      alt: "Preparate proaspete",
      title: t("home.hero2.title"),
      text: t("home.hero2.text"),
    },
    {
      key: "hero3",
      src: hero3,
      alt: "Vinuri și atmosferă",
      title: t("home.hero3.title"),
      text: t("home.hero3.text"),
      onClick: () => (window.location.href = "tel:+40268456156"),
    },
  ];

  // --- OFERTE TRIPTYCH ---
  const triptychItems = [
    {
      id: 1,
      eyebrow: t("home.triptych.i1.eyebrow"),
      title: t("home.triptych.i1.title"),
      desc: t("home.triptych.i1.desc"),
      image: Oferta1,
      ctaLabel: t("home.triptych.i1.cta"),
      href: menuHref("pizza_vatra"),
    },
    {
      id: 2,
      eyebrow: t("home.triptych.i2.eyebrow"),
      title: t("home.triptych.i2.title"),
      desc: t("home.triptych.i2.desc"),
      image: Oferta2,
      ctaLabel: t("home.triptych.i2.cta"),
      href: menuHref("pizza_party"),
    },
    {
      id: 3,
      eyebrow: t("home.triptych.i3.eyebrow"),
      title: t("home.triptych.i3.title"),
      desc: t("home.triptych.i3.desc"),
      image: Oferta3,
      ctaLabel: t("home.triptych.i3.cta"),
      href: baseMenuPath,
    },
  ];

  return (
    <PageWrap>
      <SEO
        title="La Fontanella Predeal | Pizza, Paste, Meniuri"
        description="Restaurant La Fontanella Predeal – gusturi autentice, livrare gratuită și preparate tradiționale."
      />
      <Ornament />
      <HeroCarousel
        slides={slidesHero}
        interval={3000}
        height="70vh"
        accent="#a78631"
        onMenuClick={() => navigate(baseMenuPath)}
        onContactClick={() => navigate("/contact/")}
      />
      <Ornament />

      <GalleryBlock
        eyebrow={t("home.gallery.eyebrow")}
        title={t("home.gallery.title")}
        text={t("home.gallery.text")}
        images={[
          { src: g1, alt: "Preparat mediteranean" },
          { src: g2, alt: "Echipă în bucătărie" },
          { src: g3, alt: "Plating rafinat" },
          { src: g4, alt: "Plating rafinat" },
        ]}
        interval={3000}
        onMenuClick={() => navigate(baseMenuPath)}
      />

      {/* --- FeatureTriptych doar pentru Delivery --- */}
      {!isRestaurant && (
        <>
          <Ornament />
          <FeatureTriptych
            accent="#a78631"
            heading={t("home.triptych.heading")}
            items={triptychItems}
          />
        </>
      )}

      <Ornament />
      <StorySection
        eyebrow={t("home.story.eyebrow")}
        title={t("home.story.title")}
        paragraphs={[t("home.story.p1"), t("home.story.p2")]}
        ctaLabel={t("home.gallery.cta")}
        onCtaClick={() => navigate(baseMenuPath)}
        imageSrc={poveste}
        imageAlt={t("home.gallery.title")}
      />

      <Ornament />
      <Carousel
        images={[
          { src: pizzaImg, alt: "Pizza pe vatră" },
          { src: pasteImg, alt: "Paste cremoase" },
          { src: papanasiImg, alt: "Papanași cu smântână și dulceață" },
        ]}
      />

      <Ornament />
      <ContactInfo
        brand="Restaurant La Fontanella"
        address="Bulevardul Mihai Săulescu nr.111, Predeal, România"
        mapsUrl="https://www.google.com/maps?q=Mihai+Săulescu+111,+Predeal"
        accent="#d4af37"
      />

      <Ornament />
      <Carousel
        images={[
          { src: hero1, alt: "Pizza pe vatră" },
          { src: hero2, alt: "Paste cremoase" },
          { src: hero3, alt: "Papanași cu smântână și dulceață" },
          { src: hero4, alt: "Papanași cu smântână și dulceață" },
          { src: hero5, alt: "Papanași cu smântână și dulceață" },
          { src: hero6, alt: "Papanași cu smântână și dulceață" },
          { src: hero7, alt: "Papanași cu smântână și dulceață" },
        ]}
      />

      {/* --- InfoDelivery doar pentru Delivery --- */}
      {!isRestaurant && (
        <>
          <Ornament />
          <InfoDelivery validFrom="27-01-2025" />
        </>
      )}

      <Ornament />
    </PageWrap>
  );
}
